package com.trevorwiebe.timesheet.loads.domain.model

import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus

/** The dispatch board never shows Sunday. This is the number of date tabs shown at once. */
const val DISPATCH_WINDOW_SIZE = 6

/** The first visible dispatch day: [today], unless it is Sunday, in which case the next Monday. */
fun startDispatchDay(today: LocalDate): LocalDate =
    if (today.dayOfWeek == DayOfWeek.SUNDAY) nextWorkday(today) else today

/** The next day after [date], skipping Sunday. */
fun nextWorkday(date: LocalDate): LocalDate {
    val next = date.plus(1, DateTimeUnit.DAY)
    return if (next.dayOfWeek == DayOfWeek.SUNDAY) next.plus(1, DateTimeUnit.DAY) else next
}

/** The [DISPATCH_WINDOW_SIZE] rolling dispatch dates starting at [startDispatchDay], skipping Sundays. */
fun visibleDispatchDates(today: LocalDate): List<LocalDate> {
    val dates = ArrayList<LocalDate>(DISPATCH_WINDOW_SIZE)
    var day = startDispatchDay(today)
    repeat(DISPATCH_WINDOW_SIZE) {
        dates.add(day)
        day = nextWorkday(day)
    }
    return dates
}
